// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-item {
  color: var(--ion-color-secondary);
}

form {
  margin: 0px 5px !important;
}

.dob-section {
  width: 100%;
  display: flex;
  column-gap: 12px;
}
.dob-section div {
  flex: 1;
}

.spinner-container {
  text-align: center;
  display: flex;
  flex-direction: column;
  row-gap: 16px;
  color: var(--ion-color-secondary);
}
.spinner-container span {
  font-weight: 500;
  font-size: 12px;
}
.spinner-container ion-spinner {
  color: var(--ion-color-secondary);
  margin: 10% auto auto auto;
}`, "",{"version":3,"sources":["webpack://./src/app/pages/rewards/rewards-connect/rewards-connect.page.scss"],"names":[],"mappings":"AAAA;EACI,iCAAA;AACJ;;AAEA;EACI,0BAAA;AACJ;;AAEA;EACI,WAAA;EACA,aAAA;EACA,gBAAA;AACJ;AACI;EACI,OAAA;AACR;;AAGA;EACI,kBAAA;EACA,aAAA;EACA,sBAAA;EACA,aAAA;EACA,iCAAA;AAAJ;AAEI;EACI,gBAAA;EACA,eAAA;AAAR;AAGI;EACI,iCAAA;EACA,0BAAA;AADR","sourcesContent":["ion-item {\n    color: var(--ion-color-secondary);\n}\n\nform {\n    margin: 0px 5px !important;\n}\n\n.dob-section {\n    width: 100%;\n    display: flex;\n    column-gap: 12px;\n\n    div {\n        flex: 1;\n    }\n}\n\n.spinner-container {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    row-gap: 16px;\n    color: var(--ion-color-secondary);\n\n    span {\n        font-weight: 500;\n        font-size: 12px;\n    }\n\n    ion-spinner {\n        color: var(--ion-color-secondary);\n        margin: 10% auto auto auto;\n    }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
